module.exports = __webpack_public_path__ + "static/media/profile.ab6b9df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/profile.png
// module id = 1079
// module chunks = 0